module.exports = __webpack_public_path__ + "static/media/Ku-min.811f62e3.PNG";